import React from "react";
import clsx from "clsx";
import { Card } from "@curves/ui-base";
import { Grid } from "@mui/material";
import { ReadTextField } from "@icoach/components";

const ShippingSectionByRead = props => {
	const { titleClassName = "bg-light-active", sourceData = {} } = props;
	const { shippingDayText } = sourceData;

	return (
		<React.Fragment>
			<Card.CardHeader title="出貨週期" className={clsx("px-4", titleClassName)} />
			<Card.CardContent className="p-4">
				<Grid spacing={3} container>
					<Grid xs={4} item>
						<ReadTextField label="出貨週期">{shippingDayText}</ReadTextField>
					</Grid>
				</Grid>
			</Card.CardContent>
		</React.Fragment>
	);
};

export default ShippingSectionByRead;
